<app-powerbi [orgId]="orgId"></app-powerbi>
